export default __webpack_public_path__ + "static/media/template_business-man__0026_1---paulphua.e5d7ddc1.png";